import * as React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
// @mui
import {  
  Box,
  Modal,
  Button,
  Stack
} from '@mui/material';
import { cores } from '../styles/styleUtils';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50vw',
  height: '50vh',
  '@media screen and (max-width: 600px)': {
    width: '50vw', // Width de 100% para telas de celulares
    height: '50vh',
  },
  bgcolor: 'transparent',
  border: `1px solid ${cores.chumbo}`, borderTop: `4px solid ${cores.laranja}`,
  boxShadow: 24,
  p: 2,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  background: `linear-gradient(180deg, ${cores.painelTopo} 0%, ${cores.painelBase} 100%)`,
  alignItems: 'center',
  justifyContent: 'center'
};

// ----------------------------------------------------------------------

// eslint-disable-next-line no-unused-vars
const ModalMudaFluxo = React.forwardRef((props, ref) => {
  


  return (


    <Modal
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <strong style={{ color: cores.textoClaro }}>Deseja enviar a proposta para o próximo fluxo?</strong>
          <Stack direction={'row'} justifyContent={'space-between'} gap={20} mt={5} >
            <Button variant="outlined" onClick={props.onClose} color="error"> Cancelar</Button>
            <Button variant="contained" color="success" onClick={props.onConfirm}>Finalizar</Button>
          </Stack>
        </Box> 
    </Modal> 
  );
})

ModalMudaFluxo.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func
}

export default (ModalMudaFluxo);